import * as React from "react";
import { Button } from "~/components/ui/button";
import { Modal } from "~/components/Modal";
import { ApiKey } from "../../types";
import { XIcon } from "lucide-react";

// // // //

function ConfirmModal(props: {
    show: boolean;
    apiKey: ApiKey;
    onCancel: () => void;
    onConfirm: () => void;
}) {
    const { show, apiKey, onCancel, onConfirm } = props;

    return (
        <Modal
            show={show}
            onHide={() => {
                onCancel();
            }}
        >
            <React.Fragment>
                <div className="bg-card px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0">
                            <h3
                                className="text-lg leading-6 text-foreground"
                                id="modal-headline"
                            >
                                Deactivate API Key
                            </h3>
                            <div className="mt-3">
                                <p className="text-sm text-slate-600">
                                    Are you sure you want to deactivate the{" "}
                                    <span className="font-semibold">
                                        {apiKey.name} API Key
                                    </span>
                                    ? Any applications using this API Key will
                                    no longer be able to query data from
                                    RWA.xyz. This action cannot be undone.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-slate-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                        onClick={() => onConfirm()}
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-xs px-4 py-2 bg-red-600 text-base text-white hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                        Deactivate API Key
                    </button>
                    <button
                        onClick={() => onCancel()}
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md shadow-xs px-4 py-2 bg-card text-base text-slate-800 hover:bg-slate-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                        Cancel
                    </button>
                </div>
            </React.Fragment>
        </Modal>
    );
}

/**
 * ArchiveButton
 * Display a confirmation modal before archiving an API Key
 */
export function ArchiveButton(props: {
    apiKey: ApiKey;
    loading: boolean;
    onConfirmArchive: () => void;
}) {
    const { apiKey, loading, onConfirmArchive } = props;
    const [showingModal, showModal] = React.useState(false);

    return (
        <>
            <Button
                size="xs"
                disabled={loading}
                variant="outlineDestructive"
                onClick={() => {
                    showModal(true);
                }}
            >
                <XIcon />
                Deactivate
            </Button>
            <ConfirmModal
                apiKey={apiKey}
                show={showingModal}
                onCancel={() => {
                    showModal(false);
                }}
                onConfirm={function (): void {
                    showModal(false);
                    onConfirmArchive();
                }}
            />
        </>
    );
}
